import { Injectable } from '@angular/core';
import { THEME_STORAGE_KEY } from '../services/theme.service';

/**
 * Wipes every persisted slice belonging to the outgoing session.
 *
 * The theme is deliberately carried across. index.html reads THEME_STORAGE_KEY
 * before first paint, so a blanket localStorage.clear() both discards the
 * user's dark mode choice and flashes the light theme on the next load.
 */
export function clearSessionStorage(): void {
  try {
    const theme = localStorage.getItem(THEME_STORAGE_KEY);
    localStorage.clear();
    if (theme) {
      localStorage.setItem(THEME_STORAGE_KEY, theme);
    }
  } catch {
    // localStorage may be unavailable (private mode); logging out still works.
  }
}

/**
 * Ends the session. Injectable so callers can be tested without a real
 * navigation escaping into the test runner.
 */
@Injectable({
  providedIn: 'root',
})
export class SessionTeardownService {
  public clearStorage(): void {
    clearSessionStorage();
  }

  /**
   * Leaves the Angular app entirely.
   *
   * A router.navigate() keeps the app context alive, and with it the NgRx
   * store and the rehydrate snapshot that ngrx-store-localstorage captured at
   * bootstrap. Neither is reachable by clearing localStorage, so the next
   * dispatched action writes the outgoing user's state straight back to disk.
   * A document-level load is what actually drops both.
   */
  public reloadToLogin(): void {
    window.location.assign('/auth/login');
  }
}
